// extracted by mini-css-extract-plugin
module.exports = {"form":"PhoneNumberForm_form__SiB7t","input-phone":"PhoneNumberForm_input-phone___AEQd"};